const hiddenMavenoid = hidden => {
  if (document) {
    document.body.style.overflow = hidden ? 'hidden' : 'auto';
    const mavenoidShadowRoot = document.querySelector('#mavenoid-shadow-root');

    if (mavenoidShadowRoot) {
      const mavenoidWrapper =
        mavenoidShadowRoot.shadowRoot.querySelector('#assistant-layout');

      if (mavenoidWrapper) {
        mavenoidWrapper.style.display = hidden ? 'none' : 'grid';
      }
    }
  }
};

export default hiddenMavenoid;
